import { clsx } from 'clsx';
import * as React from 'react';

import styles from './ChatMessageRow.css';

interface IChatMessageRowProps {
  errorSign?: React.ReactNode;
  errorText?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const ChatMessageRow: React.FC<IChatMessageRowProps> = ({ errorSign, errorText, children, className }) => {
  return (
    <div className={clsx(styles['message-row'], className)}>
      <div className={styles['message-row__inner']}>
        {children}

        <div className={styles['message__error-sign']}>{errorSign}</div>
      </div>

      <div className={styles['message__error-text']}>{errorText}</div>
    </div>
  );
};
